export enum ProspectusTypeEnum {
  STANDALONE = 'STANDALONE',
  BASE = 'BASE',
}

export enum ProspectusCategoryEnum {
  S15A = 'S15A',
  I15B = 'I15B',
  I15C = 'I15C',
  O15D = 'O15D',
}
